import { render, staticRenderFns } from "./TicketRequestAction.vue?vue&type=template&id=c86f3a9a&scoped=true&"
import script from "./TicketRequestAction.vue?vue&type=script&lang=ts&"
export * from "./TicketRequestAction.vue?vue&type=script&lang=ts&"
import style0 from "./TicketRequestAction.vue?vue&type=style&index=0&id=c86f3a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f3a9a",
  null
  
)

export default component.exports